import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import SEO from '@/components/SEO';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch {
      // Backend always returns 200 to avoid enumeration; showing generic success is fine
      setSent(true);
    } finally { setLoading(false); }
  };

  return (
    <>
      <SEO title="Reset password" noindex />
      <div className="min-h-[calc(100vh-5rem)] bg-sans_bone flex items-center">
        <div className="sans-container max-w-md py-16">
          <div className="sans-label mb-3">Reset password</div>
          <h1 className="font-serif text-3xl text-sans_ink">Forgot your password?</h1>
          {!sent ? (
            <>
              <p className="sans-body mt-4">Enter your email and we'll send you a link to set a new one. The link is valid for 30 minutes.</p>
              <form onSubmit={submit} className="mt-8 space-y-6">
                <div>
                  <label className="sans-label block mb-2">Email</label>
                  <input data-testid="forgot-email" className="sans-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
                </div>
                <button data-testid="forgot-submit" disabled={loading} className="sans-btn-primary w-full">{loading ? 'Sending…' : 'Send reset link'}</button>
              </form>
            </>
          ) : (
            <div className="mt-8 border border-sans_line bg-white p-6">
              <div className="font-serif text-xl text-sans_ink">Check your email.</div>
              <p className="text-sm text-sans_mute mt-3 leading-relaxed">If an account exists for <strong className="text-sans_ink">{email}</strong>, we've sent a password reset link. It's valid for 30 minutes.</p>
              <p className="text-xs text-sans_mute mt-4">Don't see it? Check spam, or request again after a few minutes.</p>
            </div>
          )}
          <div className="mt-8 text-sm text-sans_mute">
            Remembered it? <Link to="/login" className="sans-link">Sign in</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
